<template>
    <h1 v-if="content.Ueberschrift" :id="getId">{{ content.Ueberschrift }}</h1>
    <div class="standort-introText-container" v-html="content.InfoText" v-if="content.InfoText"/>
    <component :is="getComponent"/>
</template>

<script>
import MedauAngebote from "@/components/static/MedauAngebote.vue";
import MedauStandorte from "@/components/static/MedauStandorte.vue";
import MedauMitarbeiter from "@/components/static/MedauMitarbeiter.vue";

export default {
    props: [
        "content"
    ],
    computed: {
        getComponent() {
            switch (this.content.Inhalt) {
                case "Angebote":
                    return MedauAngebote;
                case "Standorte":
                    return MedauStandorte;
                case "Mitarbeiter":
                    return MedauMitarbeiter;
            }
            return null;
        },
        getId() {
            switch(this.content.Inhalt) {
                case 'Standorte':
                    return 'standorte';
                case 'Angebote':
                    return 'angebote';
                case 'Mitarbeiter':
                    return 'personen';
                default:
                    return null;
            }
        }
    }
}
</script>